import React, { } from 'react';
import { Tooltip } from 'antd';


const DcrFieldOldValueMapResolver = ({ value }) => value.oldValueMapped ? <Tooltip title={value.oldValue}>{value.oldValueMapped}</Tooltip> : value.oldValue;

export default DcrFieldOldValueMapResolver;
